import "./AlertPopup.scss";
import _ from "lodash";
import errorIcon from "assets/icons/error-popup-icon.svg";
import successIcon from "assets/icons/success-popup-icon.svg";
import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { ALERT_DISPLAY_DELAY, POPUP_STATUS } from "constants/constants";
import PropTypes from "prop-types";

const AlertPopup = ({ setCode, setStatus, code, status }) => {
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    setIsAlertVisible(false);
    if (status && code) {
      setIsAlertVisible(true);
    }
  }, [status, code]);

  useEffect(() => {
    if (isAlertVisible)
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    const timer = setTimeout(() => {
      setIsAlertVisible(false);
      setCode();
      setStatus();
    }, ALERT_DISPLAY_DELAY);

    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  return isAlertVisible ? (
    <div className="popup_alert">
      <div className={status === POPUP_STATUS.ERROR ? "error" : "success"}>
        <div>
          <div
            style={{
              backgroundImage: `url(${
                status === POPUP_STATUS.ERROR ? errorIcon : successIcon
              })`,
            }}
            className="icon_popup"
          />
        </div>
        {code &&
          intl.formatMessage({
            id: _.toLower(code),
            defaultMessage: code,
          })}
      </div>
    </div>
  ) : (
    <> </>
  );
};

export default AlertPopup;

AlertPopup.propTypes = {
  setCode: PropTypes.func,
  setStatus: PropTypes.func,
  code: PropTypes.string,
  status: PropTypes.string,
};
